import React from "react";

import { useArticulatedGoals } from "../../api/queries/useArticulatedGoals";
import { useMedicalCautions } from "../../api/queries/useMedicalCautions";
import { useStrengthCautionOptions } from "../../api/queries/useStrengthCautionOptions";
import { useStrengths } from "../../api/queries/useStrengths";

import { MedicalCautions } from "./components/MedicalCautions";
import { PatientArticulatedGoals } from "./components/PatientArticulatedGoals";
import { PatientStrengths } from "./components/PatientStrengths";

import "./GoalsStrengthsCautions.styles.scss";

export const GoalsStrengthsCautions = ({ isProviderOnCareTeam, patientId }) => {
  const { data: strengthCautionOptions, isLoading: isLoadingOptions } = useStrengthCautionOptions({
    patientId,
  });

  const {
    data: existingGoals,
    isLoading: isLoadingGoals,
    refetch: refetchGoals,
  } = useArticulatedGoals({ patientId });

  const {
    data: existingMedicalCautions,
    isLoading: isLoadingCautions,
    refetch: refetchCautions,
  } = useMedicalCautions({ patientId });

  const {
    data: existingStrengths,
    isLoading: isLoadingStrengths,
    refetch: refetchStrengths,
  } = useStrengths({ patientId });

  if (isLoadingOptions || isLoadingGoals || isLoadingCautions || isLoadingStrengths) {
    return null;
  }

  return (
    <div className="PatientGoalsStrengthsCautions">
      {existingGoals && (
        <PatientArticulatedGoals
          existingGoals={existingGoals}
          isProviderOnCareTeam={isProviderOnCareTeam}
          patientId={patientId}
          refreshGoals={refetchGoals}
        />
      )}

      {existingStrengths && (
        <PatientStrengths
          existingStrengths={existingStrengths}
          isProviderOnCareTeam={isProviderOnCareTeam}
          patientId={patientId}
          patientStrengthOptions={strengthCautionOptions?.patient_strength_options ?? []}
          refreshStrengths={refetchStrengths}
        />
      )}

      {existingMedicalCautions && (
        <MedicalCautions
          existingMedicalCautions={existingMedicalCautions}
          isProviderOnCareTeam={isProviderOnCareTeam}
          patientId={patientId}
          patientMedicalCautionOptions={strengthCautionOptions?.medical_caution_options ?? []}
          refreshCautions={refetchCautions}
        />
      )}
    </div>
  );
};
